export const addQueryParamToUrl = async (param) => {
  const url = window.location.href.split('?')[0];

  const urlZParametrem = `${url}?${param}`;

  return window.history.replaceState(null, '', urlZParametrem);
};
